module.exports = __webpack_public_path__ + "img/20220727232508308nzi.f63ce3f9.jpg";